import React from "react";
import { Collapse, Switch } from "antd";

const { Panel } = Collapse;

export const FilterField = ({ label, children }) => (
  <div className="qp-filter-field">
    {label && <label className="qp-filter-label">{label}</label>}
    {children}
  </div>
);

export const ToggleRow = ({ leftLabel, leftChecked, onLeft, rightLabel, rightChecked, onRight }) => (
  <div className="qp-filter-toggle-row">
    <span className="qp-filter-toggle-item">
      <Switch size="small" checked={leftChecked} onChange={onLeft} />
      <span className="qp-filter-toggle-text">{leftLabel}</span>
    </span>
    <span className="qp-filter-toggle-item">
      <Switch size="small" checked={rightChecked} onChange={onRight} />
      <span className="qp-filter-toggle-text">{rightLabel}</span>
    </span>
  </div>
);

export const CheckboxGrid = ({ options = [], value, onChange = () => {} }) => (
  <div className="qp-filter-checkbox-grid">
    {(Array.isArray(options) ? options : []).map((opt) => (
      <label key={opt.value} className="qp-filter-checkbox-item">
        <input
          type="checkbox"
          className="qp-filter-checkbox-input"
          checked={(Array.isArray(value) ? value : []).includes(opt.value)}
          onChange={(e) => {
            const currentValue = Array.isArray(value) ? value : [];
            const next = e.target.checked
              ? [...currentValue, opt.value]
              : currentValue.filter((v) => v !== opt.value);
            onChange(next);
          }}
        />
        <span className="qp-filter-checkbox-label">{opt.title}</span>
      </label>
    ))}
  </div>
);

export const SectionHeader = ({ icon, title, badge }) => (
  <span className="qp-filter-panel-header">
    <span className="qp-filter-panel-icon">{icon}</span>
    <span className="qp-filter-panel-title">{title}</span>
    {badge > 0 && <span className="qp-filter-section-badge">{badge}</span>}
  </span>
);

export const FilterPanel = ({ panelKey, icon, title, badge, children, ...rest }) => (
  <Panel
    key={panelKey}
    panelKey={panelKey}
    header={<SectionHeader icon={icon} title={title} badge={badge} />}
    {...rest}
  >
    {children}
  </Panel>
);
